import { HttpService } from '@/shared/api/services/HttpService.ts';
import { buildUrlForServiceName } from '@/connection/url-retriever.ts';
import conf from '@/shared/config/useConfig';

export class SharedPruefungService extends HttpService {
  protected baseUrl = `${buildUrlForServiceName(
    conf.bürgschaftserviceName,
  )}/buergschaftservice/api/private/v1/pruefungen`;
}
